import type { UnitInterface } from 'store/units/types';

type AlignmentField =
  | 'infoPanelAlignment'
  | 'warningsPanelAlignment'
  | 'flowPropertiesSizeAlignment'
  | 'flowPropertiesPxxAlignment'
  | 'flowPropertiesGraphAlignment'
  | 'feedGraphAlignment'
  | 'feedTableAlignment';

/**
 * Used for migrating old panel alignment data to new
 * panel location
 */
export const alignmentToLocation =
  (unit: UnitInterface) => (field: AlignmentField) => {
    // @ts-expect-error - field is a valid AlignmentField key but TS can't track it
    const [panelX, panelY] = unit.layout[field]
      .split(' ')
      .slice(-2)
      .map((s: string) => parseInt(s, 10));
    const [x, y] = unit.layout.loc.split(' ').map((s) => parseInt(s, 10));

    return `${x + panelX} ${y + panelY}`;
  };
